/// <reference path="questionController.js" />

(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('questionController', ['$scope', '$http', 'DataServices', 'UtilityServices', 'ValidationService', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants', function ($scope, $http, DataServices, UtilityServices, ValidationService, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants) {
        //Constants
        $scope.Constants = Constants;



        //DataServices
        $scope.configData = DataServices.configData;



        $scope.gaConfigData = DataServices.gaConfigData;

        $scope.template = DataServices.responseInfo.template;
        $scope.versionNumber = DataServices.responseInfo.versionNumber;
        $scope.role = DataServices.responseInfo.role;
        $scope.responses = DataServices.responseInfo.responses;

        $scope.sessionId = DataServices.sessionId;
        $scope.validatedPages = DataServices.validatedPages;
        $scope.validationErrors = DataServices.validationErrors;
        $scope.isAuthenticated = DataServices.isAuthenticated();

        //Utility Services
        $scope.utility = UtilityServices;
        $scope.vs = ValidationService; //required to be able to eval page.condition expressions from the survey JSON on this scope     

        //Page navigation
        $scope.navTabNum = parseInt($routeParams.navTabNum);
        $scope.pageUrl = $routeParams.pageUrl;
        $scope.page = _.find(_.find($scope.configData.navigationTabs, function (o) { return o.number == $scope.navTabNum; }).pages, function (p) { return p.url == $scope.pageUrl; });
        $scope.pageId = $scope.navTabNum + '-' + $scope.page.number;
        $scope.isPageEditable = $scope.utility.isCurrentIncidentEditable() === true && $scope.page.isEditable === true;

        //Locals
        $scope.originalResponse = DataServices.originalResponse;
        $scope.shadowResponse = DataServices.shadowResponse;
        $scope.pageWatches = [];
        $scope.isButtonLoading = [];

        // TODO: verify this is functioning as intended as is in the correct controller.
        $scope.utility.toggleClass($('header'), false, 'header_with-nav');

        //Report the virtual page visit to Google Analytics.
        DataServices.trackPageVisitWithGA('PageVisit: ' + $scope.pageUrl);

        $scope.isDH = function () {
            if ($location.path().indexOf('DH') > -1) {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.isDFFH = function () {
            if ($location.path().indexOf('DFFH') > -1) {
                return true;
            }
            else {
                return false;
            }
        }

        // Sets the question parameters that enable it to be easily located in the response JSON hierarchy
        // By abstracting it out here, we are easily able to add or modify params in the future without having to change (or add weight to) the surveydefinition.json.
        $scope.setQuestionParams = function (pIndex, sIndex, sCode) {
            return { 'pIndex': pIndex, 'sIndex': sIndex, 'sCode': sCode };
        }

        // Determines value of question. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        $scope.valueOfQuestion = function (params, qCode, sCode, sIndex, pIndex, pageId) {
            return ValidationService.val(params, $scope.responses, qCode, sCode, sIndex, pIndex, pageId || $scope.pageId);
        };

        // Returns true if a question response contains the specified value. Used for multiselect questions (like checkboxes).
        $scope.questionContains = function (params, qCode, qValue, sCode, sIndex, pIndex, pageId) {
            return ValidationService.questionContains(params, $scope.responses, qCode, qValue, sCode, sIndex, pIndex, pageId || $scope.pageId);
        }

        // Returns true if a question response contains a value. Returns false if the response is undefined or empty string.
        $scope.notEmpty = function (params, qCode, sCode, sIndex, pIndex, pageId) {
            return ValidationService.notEmpty(params, $scope.responses, qCode, sCode, sIndex, pIndex, pageId || $scope.pageId);
        }

        // sets up watches for a page item
        $scope.setupWatchesForPageItem = function (page, pIndex) {
            // Set up watches for this page item
            if (page.sections) {

                // iterate through each section defined for the page
                for (var s = 0; s < page.sections.length; s++) {
                    var section = page.sections[s];

                    // if the section itself has a condition, add a watch for it
                    if (section.condition) {
                        var cond = section.condition.replace(/p\$/g, JSON.stringify($scope.setQuestionParams(pIndex, 0, section.code)));
                        $scope.setupWatchForSectionCondition(pIndex, section, cond);
                    }

                    // iterate through each section item for the section
                    if ($scope.responses[$scope.pageId][pIndex][section.code]) {
                        for (var sIndex = 0; sIndex < $scope.responses[$scope.pageId][pIndex][section.code].length; sIndex++) {
                            // iterate through each question defined for the section
                            $scope.setupWatchesForSectionItem(section, pIndex, sIndex);
                        }
                    }
                }
            }
        }

        // sets up all watches for a section item
        $scope.setupWatchesForSectionItem = function (section, pIndex, sIndex) {
            for (var q = 0; q < section.questions.length; q++) {
                var question = section.questions[q];

                // Find all the questions whose display is conditional. When the condition changes to a 
                // false-y value, we remove any response for the question.
                if (question.condition) {
                    // subtitute the params in to the condition so the correct question is evaluated.
                    var cond = question.condition.replace(/p\$/g, JSON.stringify($scope.setQuestionParams(pIndex, sIndex, section.code)));
                    $scope.setupWatchForQuestionCondition(pIndex, section.code, sIndex, question.code, cond);
                }
            }
        }

        // Sets up a watch for a section condition
        $scope.setupWatchForSectionCondition = function (pIndex, section, condition) {
            // Ask angular to watch and notify us whenever the condition changes
            var watch = $scope.$watch(
                condition,
                // This function gets called when the condition changes
                function (newValue, oldValue) {
                    if (newValue) {
                        // If there is no response for the section, initialise one now
                        if (!$scope.responses[$scope.pageId][pIndex][section.code]) {
                            if (section.isRepeating) {
                                if (section.repeatingItemRequired) {
                                    // Add an initial item to display the section
                                    $scope.addSectionItem(0, section.code, false);
                                }
                            }
                            else {
                                $scope.responses[$scope.pageId][pIndex][section.code] = [{}];
                            }
                        }
                    }
                    else {
                        // Clear any response provided to date for the entire section as, the sections condition is now false.
                        $scope.responses[$scope.pageId][pIndex][section.code] = undefined;
                        $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, section.code, null, null);
                    }
                }
            );

            // find matching page watch to store deregister event with
            var match = $filter('filter')($scope.pageWatches, { pIndex: pIndex, sCode: section.code }, true)[0];
            if (match) {
                match.sWatch = watch;
            }
            else {
                $scope.pageWatches.push({
                    pIndex: pIndex,
                    sCode: section.code,
                    sWatch: watch,
                    sItems: []
                });
            }
        }

        // Sets up a watch for a question condition
        $scope.setupWatchForQuestionCondition = function (pIndex, sCode, sIndex, qCode, condition) {
            // Ask angular to watch and notify us whenever the condition changes
            // Store the function which unbinds the watch in an array so we can remove it if required.
            var watch = $scope.$watch(
                condition,
                // This function gets called when the condition changes
                function (newValue, oldValue) {
                    // If the condition's now false
                    if (!newValue) {
                        // Clear any response provided to date.
                        if ($scope.responses[$scope.pageId][pIndex][sCode] && $scope.responses[$scope.pageId][pIndex][sCode][sIndex]) {
                            $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode] = undefined;
                            $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, sCode, sIndex, qCode);
                        }
                    }
                }
            )

            // find matching page watch to store deregister event with
            var match = $filter('filter')($scope.pageWatches, { pIndex: pIndex, sCode: sCode }, true)[0];
            if (match) {
                if (!match.sItems[sIndex]) {
                    match.sItems[sIndex] = [];
                }
                match.sItems[sIndex].push(watch);
            }
            else {
                $scope.pageWatches.push({
                    pIndex: pIndex,
                    sCode: sCode,
                    sWatch: null,
                    sItems: [[watch]]
                });
            }

        }

        // Removes all watches in a page item. This includes section and question conditions in that page item.
        $scope.deregisterPageItemWatches = function (pIndex) {
            var watches = $filter('filter')($scope.pageWatches, { pIndex: pIndex }, true);
            if (watches) {
                for (var s = 0; s < watches.length; s++) {
                    if (watches[s].sWatch) {
                        // deregister section watch
                        watches[s].sWatch();
                    }
                    // deregister question watches in each section item
                    for (var si = 0; si < watches[s].sItems.length; si++) {
                        $scope.deregisterSectionItemWatches(pIndex, watches[s].sCode, si);
                    }
                }

                // delete watches now that they are deregistered
                $scope.pageWatches = $scope.pageWatches.filter(function (obj) {
                    return !obj.pIndex == pIndex;
                });
            }
        }

        // Removes all watches in a section item. This includes all question conditions in that section item.
        $scope.deregisterSectionItemWatches = function (pIndex, sCode, sIndex) {
            var section = $filter('filter')($scope.pageWatches, { pIndex: pIndex, sCode: sCode }, true)[0];
            if (section && section.sItems[sIndex]) {
                for (var q = 0; q < section.sItems[sIndex].length; q++) {
                    if (section.sItems[sIndex][q]) {
                        section.sItems[sIndex][q]();
                    }
                }
                // delete watches now they have been deregistered.
                section.sItems.splice(sIndex, 1);
            }
        }

        //Sets up all trigger watches (e.g. showing and hiding questions dynamically based on the trigger rules defined in JSON schema)
        $scope.setupTriggersAndDynamicValues = function () {
            // Find all the triggers. When the condition changes to a truth-y value, fire the action
            var triggers = $scope.configData.triggers;
            for (var i = 0; i < triggers.length; i++) {
                var trigger = triggers[i];

                if (trigger.whenThisExpressionChangesFromFalseToTrue != undefined) {
                    setupChangeFromFalseToTrueWatchForThisTrigger(trigger);
                }
                else if (trigger.whenThisExpressionValueChanges != undefined) {
                    setupValueChangeWatchForThisTrigger(trigger);
                }
            }

            function setupChangeFromFalseToTrueWatchForThisTrigger(trigger) {
                $scope.$watch(
                    trigger.whenThisExpressionChangesFromFalseToTrue,
                    // This function gets called when the value of the watched expression changes
                    function (newValue, oldValue) {
                        // If the condition's changed to true
                        if (newValue && !oldValue) {
                            $scope.$eval(trigger.doThis);
                        }
                    }
                );
            }

            function setupValueChangeWatchForThisTrigger(trigger) {
                $scope.$watch(
                    trigger.whenThisExpressionValueChanges,
                    // This function gets called when the value of the watched expression changes
                    function (newValue, oldValue) {
                        // If the value has changed
                        if (newValue != oldValue) {
                            $scope.$eval(trigger.doThis);
                        }
                    }, true);
            }

            // Initialise response for this page if there isn't one already, skip repeating page items so we don't end up with ghost entries
            $scope.initialisePageResponse();

            // Set up watches for questions on the page.
            if ($scope.responses[$scope.pageId]) {
                for (var pIndex = 0; pIndex < $scope.responses[$scope.pageId].length; pIndex++) {
                    $scope.setupWatchesForPageItem($scope.page, pIndex);
                }
            }
        }

        //Scroll to the appropriate anchor on the screen
        $scope.scrollTo = function (id) {
            var old = $location.hash();
            $location.hash(id);
            $anchorScroll();
            $location.hash(old); // this prevents angular from re-rendering the page
            $scope.utility.focus(id);
        };

        // Sets the focus to the heading of the Summary level validation messages
        $scope.setSummaryErrorFocus = function () {
            var summaryValMsgs = $filter('filter')($scope.validationErrors, {
                level: 'summary', pageNo: $scope.pageId
            }, true);
            if (summaryValMsgs && summaryValMsgs.length > 0) {
                $scope.scrollTo('validationInfo');
            }
        };

        // Each date will have date parts and a complete date stored in the response. 
        $scope.buildDateString = function (qCode, pIndex, sIndex, sCode) {
            var day = $scope.valueOfQuestion(null, qCode + '-day', sCode, sIndex, pIndex);
            var month = $scope.valueOfQuestion(null, qCode + '-month', sCode, sIndex, pIndex);
            var year = $scope.valueOfQuestion(null, qCode + '-year', sCode, sIndex, pIndex);

            // Set the date field in the response if all three date parts are present.
            if (day && month && year) {
                $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode] = year + '-' + month + '-' + day;
            }
            else {
                $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode] = undefined;
            }
        }

        //this method deletes individual date parts values if the full date field is undefined
        $scope.clearDateModel = function (qCode, pIndex, sIndex, sCode, dateParam) {
            if (!$scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode]) {

                $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode + dateParam] = undefined
            }
        }

        //Sets the display style for radio buttons for a question
        $scope.selectRadioAlignment = function (question) {
            if (question.displayStyle) {
                return question.displayStyle.toLowerCase();
            }
            return "vertical";
        }

        // Filter for typeahead to ensure it only searches from the beginning of the word and will consider spaces.
        $scope.typeAheadStartsWithFilter = function (option, viewValue) {
            // if option.matchingText is specified, use option.matchingText instead of option.text
            return option.matchingText ?
                (option.matchingText.substr(0, viewValue.length).toLowerCase() == viewValue.toLowerCase()) :
                (option.text && option.text.substr(0, viewValue.length).toLowerCase() == viewValue.toLowerCase());
        }

        // Gets the answer for a question from its properties.
        $scope.getAnswerFromCodes = function (params, tabNo, pageNo, sCode, qCode, pIndex, sIndex) {

            if (params) {
                if (!pIndex && params['pIndex'] != undefined) pIndex = params['pIndex'];
                if (!sIndex && params['sIndex'] != undefined) sIndex = params['sIndex'];
            }
            if (!pIndex) pIndex = 0;
            if (!sIndex) sIndex = 0;

            // Get question
            var navTab = _.find($scope.configData.navigationTabs, function (n) { return n.number == tabNo; });
            var page = _.find(navTab.pages, function (p) { return p.number == pageNo; });
            var section = _.find(page.sections, function (s) { return s.code == sCode; });
            var question = _.find(section.questions, function (q) { return q.code == qCode; });

            // Find matching response.
            var response = $scope.valueOfQuestion(null, qCode, sCode, sIndex, pIndex, tabNo + '-' + pageNo);

            return $scope.utility.getAnswer(question, response);
        }

        // Gets options from either an optionSet or options in the config
        $scope.getQuestionOptions = function (question, pIndex, sIndex, sCode) {
            // Options can be a string, in which case it is a reference to one of the named optionSets, or otherwise,
            // an array of objects, each with a code and value.
            if ((typeof question.options) === "string") {
                // If the question is dependant on another question or questions, the values for the dropdown are derived from a different option set.
                // This option set is configured in the spreadsheet as a dependancy and generated by the application at run time.
                var ops = null;
                if (sCode == null || sCode == undefined) {
                    sCode = $scope.pageUrl;
                }

                if (question.optionDependsOnQuestion) {
                    var pQuestions = question.optionDependsOnQuestion.split('|');
                    var optionSetName = question.options + '-';
                    // build the name
                    for (var i = 0; i < pQuestions.length; i++) {
                        // If the parent question has a value and its corresponding option set is available, use that optionset
                        var valOfPQuestion = $scope.valueOfQuestion(null, pQuestions[i], sCode, sIndex, pIndex, $scope.pageId);
                        if (valOfPQuestion) {
                            optionSetName = optionSetName + pQuestions[i] + '-' + valOfPQuestion;
                        }
                    };

                    ops = $scope.configData.optionSets[optionSetName];
                }

                if (ops) {
                    return ops;
                }
                else {
                    if (($location.path().indexOf('/DFFH/feedbackAssessment') > -1)) {
                        if (question.options == "category") {

                            const feedbackIndex = _.findIndex($scope.configData.optionSets[question.options], function (q) { return q.code == "feedback"; });
                            if (feedbackIndex > -1) {
                                $scope.configData.optionSets[question.options].splice(feedbackIndex, 1);
                            }
                            const aos29rIndex = _.findIndex($scope.configData.optionSets[question.options], function (q) { return q.code == "complaint-aos29r"; })
                            if (aos29rIndex > -1) {
                                $scope.configData.optionSets[question.options].splice(aos29rIndex, 1);
                            }
                        }
                    }
                    // fallback if there are no matches
                    return $scope.configData.optionSets[question.options];
                }
            }
            return question.options;
        }

        //return the IncidentDate
        $scope.getIncidentDate = function () {

            return moment(DataServices.responseInfo.incidentDate).format($scope.Constants.responseDateFormat);
        };

        $scope.confirmUserCancel = function () {

            if ($scope.pageUrl == "feedbackcoordination" || $scope.pageUrl == "followup") {
                return $scope.checkValueChangeForCoordinationPage();
            }

            // new form $scope.originalResponse aswalys null
            // cant do comparison so we will just check if any value is added to the loaded page
            if (!$scope.originalResponse['1-1']) {
                return $scope.checkAtleastOneValueOnPage($scope.navTabNum, $scope.pageUrl);
            }

            return !(angular.equals($scope.originalResponse, $scope.responses));
        };

        // Whenever a route change occurs, this event is fired.
        $scope.$on('$locationChangeStart', function (event) {
            var nextPage = $location.$$path.slice(1);

            // Allow the user to return to key navigations. TODO: It would be great if this wasn't hard coded.
            if (nextPage == Constants.Url.firstFollowUpFormPage ||
                nextPage == Constants.Url.feedbackStaffMemberLanding ||
                nextPage == Constants.Url.privacyStaffMemberLanding ||
                nextPage == Constants.Url.privacy ||
                nextPage == Constants.Url.landing ||
                nextPage == Constants.Url.firstFeedbackCoordinationFormPage ||
                nextPage == Constants.Url.firstFeedbackAdditionalInfoFormPage ||
                nextPage == Constants.Url.logout) {
                return;
            }

            // Allow the user to navigate away if the page is read only
            if ($scope.isPageEditable === false) {
                return;
            }

            // The click of Complaints and Incident link on the button to behave like cancel button
            // if clicked from followup forms
            if ((nextPage == Constants.Url.manageFeedbacks || nextPage == Constants.Url.manageComplaints || nextPage == Constants.Url.tools) &&
                ($scope.pageUrl != "consent" && $scope.pageUrl != "DHconsent" && $scope.pageUrl != "submitsuccessful") &&
                ($scope.feedbackType !== undefined ||
                    ($scope.pageUrl == "complaints" ||
                        $scope.pageUrl == "complaintsregistered" ||
                        $scope.pageUrl == "incident" ||
                        $scope.pageUrl == "followup" ||
                        $scope.pageUrl == "feedbackcoordination"))) {

                // check if values changed
                if ($scope.confirmUserCancel()) {
                    event.preventDefault();
                    $scope.callCancelFollowUp();
                }
            } else {
                // If the current page is repeating, ensure that the repeating items have been added / updated before allowing them to proceed
                if (!$scope.checkPageItemsAreSaved()) {
                    event.preventDefault();
                    return;
                }

                // Check the page is valid and meets prereqs before navigating. Some pages do not require the validation check.
                if (event.currentScope.page.navigateWithoutValidation === true ||
                    $scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {

                    // Check we can navigate to the next page before doing so.
                    // removing the logic for top button
                    // is only required for navigating between forms
                    if (!(nextPage == Constants.Url.manageFeedbacks || nextPage == Constants.Url.manageComplaints || nextPage == Constants.Url.tools)) {
                        if ($scope.isPrerequisitePageValidationMet(nextPage)) {
                            return;
                        }
                        else {
                            event.preventDefault();
                            $scope.utility.openPopup('prereqPageValidationFailed');
                        }
                    }
                }
                else {
                    event.preventDefault();
                    $scope.alertFirstError();
                }
            }
        });


        // Determines if the user can navigate to the page based on what they have currently entered in the form
        $scope.isPrerequisitePageValidationMet = function (nextPage) {
            try {
                // Determine prerequisite page validation has been completed before navigating to the destination page.
                var route = nextPage.split('/');
                if (route.length == 4) {
                    var navTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == parseInt(route[2]); });
                    if (navTab) {
                        var destPage = _.find(navTab.pages, function (o) { return o.url == route[3]; });
                        if (destPage) {
                            if (destPage.prerequisitePageValidation) {
                                var pagesToCheck = destPage.prerequisitePageValidation.split('|');
                                for (var i = 0; i < pagesToCheck.length; i++) {
                                    if ($scope.validatedPages.indexOf(pagesToCheck[i]) < 0) {
                                        return false;
                                    }
                                };
                            }
                            return true;
                        }
                    }
                }
                else if ($location.path().indexOf('DFFH') > -1) {
                    var navTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == parseInt(route[3]); });
                    if (navTab) {
                        var destPage = _.find(navTab.pages, function (o) { return o.url == route[4]; });
                        if (destPage) {
                            if (destPage.prerequisitePageValidation) {
                                var pagesToCheck = destPage.prerequisitePageValidation.split('|');
                                for (var i = 0; i < pagesToCheck.length; i++) {
                                    if ($scope.validatedPages.indexOf(pagesToCheck[i]) < 0) {
                                        return false;
                                    }
                                };
                            }
                            return true;
                        }
                    }
                }
                else if ($location.path().indexOf('DH') > -1) {
                    var navTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == parseInt(route[3]); });
                    if (navTab) {
                        var destPage = _.find(navTab.pages, function (o) { return o.url == route[4]; });
                        if (destPage) {
                            if (destPage.prerequisitePageValidation) {
                                var pagesToCheck = destPage.prerequisitePageValidation.split('|');
                                for (var i = 0; i < pagesToCheck.length; i++) {
                                    if ($scope.validatedPages.indexOf(pagesToCheck[i]) < 0) {
                                        return false;
                                    }
                                };
                            }
                            return true;
                        }
                    }
                }
                return false;
            }
            catch (e) {
                // if there is any error with parsing or determining the prerequisites for the page, return false.
                return false;
            }
        }

        // this function sets the street, suburb, postcode, locality when the user selects the address from google auto complete address
        $scope.setAddressParts = function (address, response, qCode) {
            //clearing the previous address field values before populating new ones
            response[qCode + '-autoSuburb'] = undefined;
            response[qCode + '-autoState'] = undefined;
            response[qCode + '-stateCode'] = undefined;
            response[qCode + '-autoPostCode'] = undefined;
            response[qCode + '-lga'] = undefined;
            response[qCode + '-autoStreetNumberName'] = undefined;

            if (address) {
                var streetAddress = '';

                for (var i = 0; i < address.length; i++) {
                    var addressType = address[i].types[0];
                    if (addressType == 'street_number') {
                        streetAddress += address[i].long_name + ' ';
                    }
                    if (address[i].types[0] == 'route') {
                        streetAddress += address[i].long_name;
                    }
                    if (addressType == 'locality') {
                        response[qCode + '-autoSuburb'] = address[i].long_name;
                    }
                    if (addressType == 'administrative_area_level_1') {
                        response[qCode + '-autoState'] = address[i].long_name;
                        response[qCode + '-stateCode'] = address[i].short_name;
                    }
                    if (addressType == 'postal_code') {
                        response[qCode + '-autoPostCode'] = address[i].long_name;
                    }
                    if (addressType == 'administrative_area_level_2') {
                        response[qCode + '-lga'] = address[i].short_name;
                    }
                }

                response[qCode + '-autoStreetNumberName'] = streetAddress;
            }
        }

        // Hard validates the questions for the supplied page. Page Index, Section Code and Section Index can be provided to reduce the scope of the hard validation
        $scope.validatePage = function (navTabNum, pageUrl, pIndex, sCode, sIndex, level, dontClearPreviousErrors, noMandatoryChecksForSave) {
            var isValid = true;
            var page = getPage(navTabNum, pageUrl);
            if ($scope.$eval(page.condition, null) === false) {
                return true;
            }
            var sections = _.find(_.find($scope.configData.navigationTabs, function (o) { return o.number == navTabNum; }).pages, function (p) { return p.url == pageUrl; }).sections;
            if (sections) {
                //Generally in most of places, each page is  validated in the application when navigating away from page, the places where the whole form has to be validated at once, we would like to interate through all the pages
                //and call this function to validate page by page, In such case we would like to retain all the errors of previous pages we we iterate through.
                if (dontClearPreviousErrors === null || dontClearPreviousErrors === undefined) {
                    // reset validationErrors array
                    $scope.validationErrors.length = 0;
                }

                var _level = null;
                if (level == null || level == undefined) {
                    _level = 'summary';
                } else {
                    _level = level;
                }

                var pageIdentifier = $scope.pageId;

                if ($scope.responses[pageIdentifier]) {
                    for (var pi = 0; pi < $scope.responses[pageIdentifier].length; pi++) {
                        if (pIndex == null || pIndex == pi) {
                            for (var s = 0; s < sections.length; s++) {
                                var section = sections[s];
                                if (sCode == null || section.code == sCode) {
                                    if ($scope.responses[pageIdentifier][pi][section.code]) {
                                        for (var si = 0; si < $scope.responses[pageIdentifier][pi][section.code].length; si++) {
                                            if (sIndex == null || sIndex == si) {
                                                if (!section.condition || $scope.$eval(section.condition, { p$: $scope.setQuestionParams(pi, 0, section.code) }) === true) {
                                                    $.each(section.questions, function () {
                                                        isValid = $scope.validatePageQuestions(_level, this, pi, si, section.code, noMandatoryChecksForSave) && isValid;
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Update the valid pages array with the outcome of this validation
            if (isValid) {
                if ($scope.validatedPages.indexOf(pageIdentifier) === -1) {
                    $scope.validatedPages.push(pageIdentifier);
                }
            }
            else {
                var index = $scope.validatedPages.indexOf(pageIdentifier);
                if (index > -1) {
                    $scope.validatedPages.splice(index, 1);
                }
            }
            return isValid;
        };

        // Check if any value is added to the forum
        $scope.checkAtleastOneValueOnPage = function (navTabNum, pageUrl) {
            var hasValue = false;

            var sections = _.find(_.find($scope.configData.navigationTabs, function (o) { return o.number == navTabNum; }).pages, function (p) { return p.url == pageUrl; }).sections;
            if (sections) {
                if ($scope.responses[$scope.pageId]) {
                    for (var pi = 0; pi < $scope.responses[$scope.pageId].length; pi++) {

                        for (var s = 0; s < sections.length; s++) {
                            var section = sections[s];

                            if ($scope.responses[$scope.pageId][pi][section.code]) {
                                for (var si = 0; si < $scope.responses[$scope.pageId][pi][section.code].length; si++) {
                                    $.each(section.questions, function () {

                                        var question = this;
                                        if ($scope.notEmpty($scope.setQuestionParams(pi, si, section.code), question.code) === true) {
                                            hasValue = true;
                                            return false; // this will break the current .each() 
                                        }

                                    });
                                }
                            }
                        }
                    }
                }
            }

            return hasValue;
        };


        // Determines if a questions response is valid. Errors are populated in the validationErrors JSON
        $scope.validatePageQuestions = function (level, question, pIndex, sIndex, sCode, noMandatoryChecksForSave) {
            var isValid = true;
            // check if question is displayed first
            if (!question.condition || $scope.$eval(question.condition, { p$: $scope.setQuestionParams(pIndex, sIndex, sCode) }) === true) {
                if (question.validations && question.access !== 'R') {
                    $.each(question.validations, function () {
                        //This condition will be passed when form is saved, where we do not perform mandatory checks
                        if (noMandatoryChecksForSave === true) {
                            if (this.rule.indexOf('notEmpty') > -1) {
                                return;
                            }
                        }
                        if (this.level == level.toLowerCase()) {
                            if ($scope.$eval(this.rule, { p$: $scope.setQuestionParams(pIndex, sIndex, sCode, $scope.pageId) }) != true) {
                                isValid = false;
                                $scope.addValidationError(this.level, $scope.pageId, pIndex, sIndex, sCode, question.code, this.popupMessageCode, question.shortQuestion ? question.shortQuestion : question.question, this.summaryMessage, this.inlineMessage);
                                return false; // this will break the current .each() as we only want the first error per question
                            }
                        }
                    });
                }
            }
            return isValid;
        }

        // Determines if a questions response is valid. Errors are populated in the validationErrors JSON
        $scope.validateQuestion = function (level, question, pIndex, sIndex, sCode) {
            var isValid = true;

            // check if question is displayed first
            if (!question.condition || $scope.$eval(question.condition, { p$: $scope.setQuestionParams(pIndex, sIndex, sCode) }) === true) {
                if (question.validations && question.access !== 'R') {
                    $.each(question.validations, function () {
                        if (this.level == level.toLowerCase() || level.toLowerCase() == 'summary') {
                            if ($scope.$eval(this.rule, { p$: $scope.setQuestionParams(pIndex, sIndex, sCode) }) != true) {
                                isValid = false;
                                $scope.addValidationError(this.level, $scope.pageId, pIndex, sIndex, sCode, question.code, this.popupMessageCode, question.shortQuestion ? question.shortQuestion : question.question, this.summaryMessage, this.inlineMessage);
                                return false; // this will break the current .each() as we only want the first error per question
                            }
                        }
                    });
                }
            }
            return isValid;
        }

        // Validates the question for immediate inline validation
        $scope.validateQuestionInline = function (level, question, pIndex, sIndex, sCode) {
            // Remove any errors relating to this question before validating.
            $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, sCode, sIndex, question.code);
            $scope.validateQuestion(level, question, pIndex, sIndex, sCode);
        }

        // Add validation error to the array
        $scope.addValidationError = function (level, pageNo, pIndex, sIndex, sCode, qCode, popupMessageCode, shortQuestion, summaryMessage, inlineMessage) {
            $scope.validationErrors.push({
                'level': level,
                'pageNo': pageNo,
                'pageIndex': pIndex,
                'sectionCode': sCode,
                'sectionIndex': sIndex,
                'questionCode': qCode,
                'popupMessageCode': popupMessageCode,
                'shortQuestion': shortQuestion,
                'summaryMessage': summaryMessage,
                'inlineMessage': inlineMessage
            });
        }

        // Fires when a question value changes.
        $scope.onValueChange = function (level, question, pIndex, sIndex, sCode) {

            // Remove validation errors as question value is changing and therefore it will be re-evaluated.
            $scope.utility.removeFromValidationErrors(level, $scope.pageId, pIndex, sCode, sIndex, question.code);

            // If the question has an onChange action, fire it now.
            if (question.onChangeAction) {
                $scope.$eval(question.onChangeAction);
            }
        }

        // Sets error state for the question and its fieldset. Saves multiple watches per question.
        $scope.setErrorState = function (qCode, pIndex, sIndex, sCode) {
            var error = $filter('filter')($scope.validationErrors, {
                questionCode: qCode, pageIndex: pIndex, sectionIndex: sIndex, sectionCode: sCode
            }, true);
            // we must always call this, even when there is no error, to set the appropriate aria tags
            $scope.utility.setQuestionErrorState($scope.getQuestionId(qCode, pIndex, sIndex, sCode), error.length > 0);
        }

        // Displays a popup for the first error on the page.
        $scope.alertFirstError = function () {
            if ($scope.validationErrors.length > 0) {
                var err = $scope.validationErrors[0];
                if (err.popupMessageCode) {
                    $scope.utility.openPopup($scope.validationErrors[0].popupMessageCode).result.then(function (result) {
                        $scope.moveToFirstError();
                    });
                }
                else {
                    $scope.setSummaryErrorFocus();
                }
            }
        }

        // Moves to the first error on the page.
        $scope.moveToFirstError = function () {
            if ($scope.validationErrors.length > 0) {
                var err = $scope.validationErrors[0];
                $scope.scrollTo($scope.getQuestionId(err.questionCode, err.pageIndex, err.sectionIndex, err.sectionCode));
            }
        }

        // Numeric validation check. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        $scope.validNumeric = function (params, qCode, maxNumericLength, minNumericLength, sCode, sIndex, pIndex) {
            return ValidationService.validNumeric(params, $scope.responses, qCode, maxNumericLength, minNumericLength, sCode, sIndex, pIndex, $scope.pageId);
        }

        // Alphabetic validation check.
        $scope.validAlphabetic = function (params, qCode, sCode, sIndex, pIndex) {
            return ValidationService.validAlphabetic(params, $scope.responses, qCode, sCode, sIndex, pIndex, $scope.pageId);
        }

        // Email validation logic. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        $scope.validEmailAddress = function (params, qCode, sCode, sIndex, pIndex) {
            return ValidationService.validEmailAddress(params, $scope.responses, qCode, sCode, sIndex, pIndex, $scope.pageId);
        }

        // Determines if the date is valid. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        $scope.validDate = function (params, qCode, sCode, sIndex, pIndex, pageId) {
            return ValidationService.validDate(params, $scope.responses, qCode, sCode, sIndex, pIndex, pageId || $scope.pageId);
        }

        // this validates the date is same or after the date
        $scope.isDateSameOrAfter = function (params, qCode, minYear, sCode, sIndex, pIndex, pageId) {
            return ValidationService.isDateSameOrAfter(params, $scope.responses, qCode, minYear, sCode, sIndex, pIndex, pageId || $scope.pageId);
        }

        // this retruns the no of days in difference between dates
        $scope.dateDifferenceInDays = function (sourceDate, targetDate) {
            return ValidationService.dateDifferenceInDays(sourceDate, targetDate);
        }

        // determine where a date is past, future or today
        $scope.validDateRange = function (params, qCode, sCode, sIndex, pIndex) {
            return ValidationService.validDateRange(params, $scope.responses, qCode, sCode, sIndex, pIndex, $scope.pageId);
        }

        // Returns true if a date has been entered and it is equal to or greater than 18 years.  DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        $scope.isAdult = function (params, qCode, sCode, sIndex, pIndex) {
            return ValidationService.isAdult(params, $scope.responses, qCode, sCode, sIndex, pIndex, $scope.pageId);
        }


        //Takes the user to the specified page if the condition is met, otherwise they go to the next page in sequence
        $scope.goToNextPageConditional = function (conditionNavNo, conditionPageUrl, condition) {
            if (condition === true) {
                DataServices.callingPage = $location.$$path.slice(1);

                // check for exit conditions
                if (!$scope.page.exitCondition) {
                    $location.path(getCurTemplatePath() + '/' + conditionNavNo + "/" + conditionPageUrl);
                }
                else {
                    var successFunction = function () { $location.path(getCurTemplatePath() + '/' + conditionNavNo + "/" + conditionPageUrl); };
                    var failureFunction = function () { $scope.utility.openPopup($scope.page.exitConditionPopup); };
                    $scope.$eval($scope.page.exitCondition, { successFunction: successFunction, failureFunction: failureFunction, nextPageUrl: conditionPageUrl });
                }
            }
            else {
                $scope.goToNextPage();
            }
        }

        //Goes to the next page
        $scope.goToNextPage = function () {
            // check for exit conditions
            if (!$scope.page.exitCondition) {
                transferToNextPage();
            }
            else {
                var successFunction = function () { transferToNextPage(); };
                var failureFunction = function () { $scope.utility.openPopup($scope.page.exitConditionPopup); };
                $scope.$eval($scope.page.exitCondition, { successFunction: successFunction, failureFunction: failureFunction });
            }
        }

        //Goes to the previous page
        $scope.goToPreviousPage = function () {
            // check for exit conditions
            if (!$scope.page.exitCondition) {
                transferToPreviousPage();
            }
            else {
                var successFunction = function () { transferToPreviousPage(); };
                var failureFunction = function () { $scope.utility.openPopup($scope.page.exitConditionPopup); };
                $scope.$eval($scope.page.exitCondition, { successFunction: successFunction, failureFunction: failureFunction });
            }
        };

        // Returns the user to the calling page
        $scope.returnToCallingPage = function () {
            $location.path(DataServices.callingPage);
            DataServices.callingPage = undefined;
        }

        //Returns the unique question Id
        $scope.getQuestionId = function (qCode, pIndex, sIndex, sCode) {
            if (!qCode) {
                return '';
            }
            return pIndex + '-' + sCode + '-' + sIndex + '-' + qCode;
        }


        $scope.displayOnQuestion = function (question) {
            if (($location.path().indexOf('DFFH/complaintRegistered/') > -1)) {
                if (question.code == "cDActingOnBehalfOfAnotherPerson") {
                    return false;
                }
            }
            return true;
        }
        //Returns ToolTipText of question
        $scope.getToolTipText = function (question, tooltip) {

            if (($location.path().indexOf('/DH/feedbackAssessment') > -1)) {
                if (question.code == "faCategory") {
                    tooltip.tooltipText = "Select the relevant option. " +
                        "<ul>" +
                        "<li>Tier 1 - First point of contact complaint resolution by frontline service staff, where possible.</li>" +
                        "<li>Tier 2 - A complaint escalated from Tier 1 or a complaint managed by a Senior Manager. A complaint may be categorised as a Tier 2 or 3 due to complexity or severity of issues raised.</li>" +
                        "<li>Tier 3 - An independent review of a complaint investigation.</li>" +
                        "<li>Request for contact - feedback provided and requiring further contact</li>" +
                        "<li>External Oversight - A matter received from an external oversight or regulatory body requiring action.</li>" +
                        "<li>AO s29R - A complaint received about the exercise of a power by an Authorised Officer under the Child Wellbeing and Safety Act 2005. </li>" +
                        "<li>Feedback - information about the quality of service delivery that is to be used as a basis for improvement.</li>" +
                        "</ul>" +
                        "Please ensure that the categorisation is in line with the Compliment and Complaints Management Procedure."
                }
            }
            if (($location.path().indexOf('/DH/complaint') > -1)) {
                if (question.code == "cDActingOnBehalfOfAnotherPerson") {
                    tooltip.tooltipText = "Select if the feedback is on behalf of someone else. <br /><br />" +
                        "We may share the information you have submitted with the person/s on whose behalf you are making this submission."
                }
                if (question.code == "cDRequireInterpreter") {
                    tooltip.tooltipText = "Select whether the person you are acting on behalf of require an interpreter.";
                }
                if (question.code == "cDInterpreterLanguage") {
                    tooltip.tooltipText = "Select the required interpreter language. If the language is not in the list, select Other and tell us which language needed";
                }

            }


            return tooltip.tooltipText;

        }

        // Returns only the buttons for the page that satisfy or do not satisfy the position supplied.
        $scope.filterButtons = function (position, include) {
            if ($scope.page.buttons) {
                return $scope.page.buttons.filter(function (o) { return include ? o.position == position : o.position != position });
            } else {
                return null;
            }
        }

        //Focuses on the element specified by id
        $scope.goToElement = function (id) {
            document.getElementById(id).focus();
        }

        // Scrolls to the appropriate anchor on the screen, taking in to account repeating page and section items.
        $scope.pageScrollTo = function (page, error) {
            if (page.isRepeating) {
                if ($scope.getPageItemCount($scope.pageId) > 0 && $scope.getPageItemState(error.pageIndex) == Constants.RepeatingItemState.viewing) {
                    // page is repeating, and has atleast one item: so open it up before we navigate to it.
                    $scope.editPageItem(error.pageIndex);
                }
                if (page.validation && page.navigateFromSummaryFocusItem) {
                    // page is repeating, but has no items, but has page level validation
                    $scope.scrollTo(page.navigateFromSummaryFocusItem);
                }
            }

            var section = $filter('filter')(page.sections, { 'code': error.sectionCode }, true)[0];
            if (section && section.isRepeating) {
                // section is repeating, so open it up before we navigate to it
                $scope.editSectionItem(error.pageIndex, error.sectionIndex, error.sectionCode);
            }

            // Now navigate to the error.
            if (error.sectionCode) {
                $scope.scrollTo($scope.getQuestionId(error.questionCode, error.pageIndex, error.sectionIndex, error.sectionCode));
            }
        }

        // Gets the page item state.  Possible options are Adding, Editing, Viewing or undefined
        $scope.getPageItemState = function (pIndex) {
            if ($scope.responses[$scope.pageId]) {
                var item = $scope.responses[$scope.pageId][pIndex];
                if (item) {
                    return item.$state;
                }
            }
            return undefined;
        }

        // Sets the current state of the page item. Possible options are Adding, Editing, Viewing
        $scope.setPageItemState = function (pIndex, state) {
            if ($scope.responses[$scope.pageId]) {
                if ($scope.responses[$scope.pageId][pIndex]) {
                    $scope.responses[$scope.pageId][pIndex].$state = state;
                }
            }
        }

        // Determines if any page items are currently being added (state == Adding)
        $scope.isAddingPageItem = function () {
            if ($scope.responses[$scope.pageId]) {
                var matches = $filter('filter')($scope.responses[$scope.pageId], { $state: Constants.RepeatingItemState.adding }, true);
                if (matches && matches.length > 0) {
                    return true;
                }
            }
            return false;
        }

        // Adds a page item to the response
        $scope.addPageItem = function () {
            // Push new response for new page item to bind to, as well as any of its sections that are not repeating items.
            var newResponse = {
                id: generateGuid()
            };

            if (!$scope.responses[$scope.pageId]) {
                $scope.responses[$scope.pageId] = [newResponse];
            }
            else {
                $scope.responses[$scope.pageId].push(newResponse);
            }

            var page = getPage($scope.navTabNum, $scope.pageUrl);

            var pIndex = $scope.responses[$scope.pageId].length - 1;

            // initialise response for each section if there isn't one already, except for repeating section items
            if (page.sections != undefined) {
                for (var s = 0; s < page.sections.length; s++) {
                    var section = page.sections[s];
                    if (!section.isRepeating) {
                        if ($scope.responses[$scope.pageId][pIndex][section.code] == undefined) {
                            $scope.responses[$scope.pageId][pIndex][section.code] = [{}];
                        }
                    }
                }
            }

            // Set up watches for this page item
            $scope.setupWatchesForPageItem(page, pIndex);

            // Set state of page item to adding
            $scope.setPageItemState(pIndex, Constants.RepeatingItemState.adding);

            // Work with the live response, but store copy of page item in shadow response in the event the changes want to be cancelled.
            $scope.shadowResponse[pIndex] = angular.copy($scope.responses[$scope.pageId][pIndex]);

            $scope.focusFirstElement(page, pIndex, null, 0);
        }

        // Validates and saves a page item in the response
        $scope.saveNewPageItem = function (pIndex) {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, pIndex)) {
                $scope.setPageItemState(pIndex, Constants.RepeatingItemState.viewing);

                // set the shadow response to equal the response as the change is being accepted
                $scope.shadowResponse[pIndex] = angular.copy($scope.responses[$scope.pageId][pIndex]);

                //focus the 'add' button
                $scope.utility.focus('pageAddNewButton');
            }
            else {
                $scope.alertFirstError();
            }
        }

        // Cancels and removes a page item from the response
        $scope.cancelNewPageItem = function (pIndex) {
            // Remove the page error if any errors           
            $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, null, null, null);

            // Remove the new response for the page item, if no page items are left, delete the array.
            $scope.responses[$scope.pageId].splice(pIndex, 1);
            if ($scope.responses[$scope.pageId].length == 0) {
                delete $scope.responses[$scope.pageId];
            }

            // Remove the shadow response for this page item
            $scope.shadowResponse.splice(pIndex, 1);

            // deregister watches for this page item
            $scope.deregisterPageItemWatches(pIndex);

            //focus the 'add' button
            $scope.utility.focus('pageAddNewButton');
        }

        // Validates and saves an existing page item in the response
        $scope.saveExistingPageItem = function (pIndex) {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, pIndex)) {
                $scope.setPageItemState(pIndex, Constants.RepeatingItemState.viewing);

                // set the shadow response to equal the response as the change is being accepted
                $scope.shadowResponse[pIndex] = angular.copy($scope.responses[$scope.pageId][pIndex]);

                //focus the 'edit' button
                $scope.utility.focus('pageEdit-' + pIndex);
            }
            else {
                $scope.alertFirstError();
            }
        }

        // Undo changes to an existing page item in the response using the shadow copy
        $scope.cancelExistingPageItem = function (pIndex) {
            // Remove the page error if any errors           
            $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, null, null, null);
            // set the response to use the shadowresponse as the change is being cancelled.
            $scope.responses[$scope.pageId][pIndex] = angular.copy($scope.shadowResponse[pIndex]);

            $scope.setPageItemState(pIndex, Constants.RepeatingItemState.viewing);

            //focus the 'edit' button
            $scope.utility.focus('pageEdit-' + pIndex);
        }

        // Opens an existing page item for editing
        $scope.editPageItem = function (pIndex) {
            $scope.setPageItemState(pIndex, Constants.RepeatingItemState.editing);

            // Work with the live response, but store copy of page item in shadow response in the event the changes want to be cancelled.
            $scope.shadowResponse[pIndex] = angular.copy($scope.responses[$scope.pageId][pIndex]);

            var page = getPage($scope.navTabNum, $scope.pageUrl);
            $scope.focusFirstElement(page, pIndex, null, 0);
        }

        // Deletes an existing page item from the response
        $scope.deletePageItem = function (pIndex, popupConfirmCode) {

            // Confirm delete via popup
            var params = $scope.responses[$scope.pageId][pIndex];
            $scope.utility.openPopup(popupConfirmCode, params).result.then(function (result) {

                // Remove the response for the page item (and the array itself if no page items are left)
                $scope.responses[$scope.pageId].splice(pIndex, 1);
                if ($scope.responses[$scope.pageId].length == 0) {
                    delete $scope.responses[$scope.pageId];
                }

                // Remove the shadow response for this page item
                if ($scope.shadowResponse[pIndex]) {
                    $scope.shadowResponse.splice(pIndex, 1);
                }

                // deregister watches for this page item
                $scope.deregisterPageItemWatches(pIndex);

                //revalidate to ensure any validation errors shown are updated
                $scope.validatePage($scope.navTabNum, $scope.pageUrl);
                var page = getPage($scope.navTabNum, $scope.pageUrl);

                //If page item got repeating required make sure after deleting show page item
                if (page.repeatingItemRequired && pIndex == 0 && $scope.getPageItemCount($scope.pageId) === 0) {
                    $scope.addPageItem();
                } else {
                    $scope.utility.focus('pageAddNewButton');
                }
                //focus on add button

            });
        }


        // Gets the sectionItem state.  Possible options are Adding, Editing, Viewing or undefined
        $scope.getSectionItemState = function (pIndex, sIndex, sCode) {
            if ($scope.responses[$scope.pageId][pIndex][sCode]) {
                var item = $scope.responses[$scope.pageId][pIndex][sCode][sIndex];
                if (item) {
                    return item.$state;
                }
            }
            return undefined;
        }

        // Sets the current state of the section item. Possible options are Adding, Editing, Viewing
        $scope.setSectionItemState = function (pIndex, sIndex, sCode, state) {
            if ($scope.responses[$scope.pageId][pIndex][sCode]) {
                if ($scope.responses[$scope.pageId][pIndex][sCode][sIndex]) {
                    $scope.responses[$scope.pageId][pIndex][sCode][sIndex].$state = state;
                }
            }
        }

        // Determines if any section items are currently being added (state == Adding)
        $scope.isAddingSectionItem = function (pIndex, sCode) {
            if ($scope.responses[$scope.pageId][pIndex][sCode]) {
                var matches = $filter('filter')($scope.responses[$scope.pageId][pIndex][sCode], { $state: Constants.RepeatingItemState.adding }, true);
                if (matches && matches.length > 0) {
                    return true;
                }
            }
            return false;
        }

        // Adds a section item to the repsonse 
        $scope.addSectionItem = function (pIndex, sCode, noFocusRequired) {
            // Push new response for new section item to bind to           
            if (!$scope.responses[$scope.pageId][pIndex][sCode]) {
                $scope.responses[$scope.pageId][pIndex][sCode] = [{}];
            }
            else {
                $scope.responses[$scope.pageId][pIndex][sCode].push({});
            }

            // set up watches for this section item
            var page = getPage($scope.navTabNum, $scope.pageUrl);
            var section = $filter('filter')(page.sections, {
                code: sCode
            }, true)[0];
            var sIndex = $scope.responses[$scope.pageId][pIndex][sCode].length - 1;
            $scope.setupWatchesForSectionItem(section, pIndex, sIndex);

            // Set section item state to adding
            $scope.setSectionItemState(pIndex, ($scope.responses[$scope.pageId][pIndex][sCode].length - 1), sCode, Constants.RepeatingItemState.adding);

            // Work with the live response, but store copy of section item in shadow response in the event the changes want to be cancelled.
            if (!$scope.shadowResponse[pIndex]) {
                $scope.shadowResponse[pIndex] = [];
            }
            if (!$scope.shadowResponse[pIndex][sCode]) {
                $scope.shadowResponse[pIndex][sCode] = [];
            }
            if (!$scope.shadowResponse[pIndex][sCode][sIndex]) {
                $scope.shadowResponse[pIndex][sCode][sIndex] = angular.copy($scope.responses[$scope.pageId][pIndex][sCode][sIndex]);
            }

            if (noFocusRequired) {
                $scope.focusFirstElement($scope.page, pIndex, null, 0);
            }
        }

        // Validates and saves a section item to the response
        $scope.saveNewSectionItem = function (pIndex, sIndex, sCode) {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, pIndex, sCode, sIndex)) {
                $scope.setSectionItemState(pIndex, sIndex, sCode, Constants.RepeatingItemState.viewing);

                // set the shadow response to equal the response as the change is being accepted
                $scope.shadowResponse[pIndex][sCode][sIndex] = angular.copy($scope.responses[$scope.pageId][pIndex][sCode][sIndex]);

                $scope.utility.focus('sectionAddNewButton-' + pIndex + '-' + sCode);
            }
            else {
                $scope.alertFirstError();
            }
        }

        // Cancels and removes a section item from the response
        $scope.cancelNewSectionItem = function (pIndex, sIndex, sCode) {

            // remove the errors from the section           
            $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, sCode, sIndex, null);

            // Remove the new response for the section item, if no section items are left, delete the section.
            $scope.responses[$scope.pageId][pIndex][sCode].splice(sIndex, 1);
            if ($scope.responses[$scope.pageId][pIndex][sCode].length == 0) {
                delete $scope.responses[$scope.pageId][pIndex][sCode];
            }

            // Remove the shadow response for this section item
            $scope.shadowResponse[pIndex][sCode].splice(sIndex, 1);

            // deregister watches for this section item
            $scope.deregisterSectionItemWatches(pIndex, sCode, sIndex);

            $scope.utility.focus('sectionAddNewButton-' + pIndex + '-' + sCode);
        }

        // Validates and saves an existing section item in the response
        $scope.saveExistingSectionItem = function (pIndex, sIndex, sCode) {
            if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, pIndex, sCode, sIndex, undefined, true, undefined)) {
                $scope.setSectionItemState(pIndex, sIndex, sCode, Constants.RepeatingItemState.viewing);

                // set the shadow response to equal the response as the change is being accepted
                $scope.shadowResponse[pIndex][sCode][sIndex] = angular.copy($scope.responses[$scope.pageId][pIndex][sCode][sIndex]);

                $scope.utility.focus('sectionEdit-' + pIndex + '-' + sCode + '-' + sIndex);
            }
            else {
                $scope.alertFirstError();
            }
        }

        // Undo changes to an existing section item in the response using the shadow copy
        $scope.cancelExistingSectionItem = function (pIndex, sIndex, sCode) {

            // remove the errors from the section //pageNo // sectionIndex // sectionCode //pageIndex // pageNo           
            $scope.utility.removeFromValidationErrors(null, $scope.pageId, pIndex, sCode, sIndex, null);

            // set the response to use the shadowresponse as the change is being cancelled.
            $scope.responses[$scope.pageId][pIndex][sCode][sIndex] = angular.copy($scope.shadowResponse[pIndex][sCode][sIndex]);

            $scope.setSectionItemState(pIndex, sIndex, sCode, Constants.RepeatingItemState.viewing);

            $scope.utility.focus('sectionEdit-' + pIndex + '-' + sCode + '-' + sIndex);
        }

        // Opens an existing section item for editing, creating a shadow copy for undo purposes.
        $scope.editSectionItem = function (pIndex, sIndex, sCode) {
            $scope.setSectionItemState(pIndex, sIndex, sCode, Constants.RepeatingItemState.editing);

            // Work with the live response, but store copy of section item in shadow response in the event the changes want to be cancelled.
            if (!$scope.shadowResponse[pIndex]) {
                $scope.shadowResponse[pIndex] = [];
            }
            if (!$scope.shadowResponse[pIndex][sCode]) {
                $scope.shadowResponse[pIndex][sCode] = [];
            }

            $scope.shadowResponse[pIndex][sCode][sIndex] = angular.copy($scope.responses[$scope.pageId][pIndex][sCode][sIndex]);

            var page = getPage($scope.navTabNum, $scope.pageUrl);
            $scope.focusFirstElement(page, pIndex, sCode, sIndex);
        }

        // Deletes an existing section item from the response
        $scope.deleteSectionItem = function (pIndex, sIndex, sCode, popupConfirmCode) {
            var params = $scope.responses[$scope.pageId][pIndex][sCode][sIndex];

            // confirm delete via popup before proceeding.
            $scope.utility.openPopup(popupConfirmCode, params).result.then(function (result) {

                // Remove the section item from the response (and the array itself if no page items are left)
                $scope.responses[$scope.pageId][pIndex][sCode].splice(sIndex, 1);
                if ($scope.responses[$scope.pageId][pIndex][sCode].length == 0) {
                    delete $scope.responses[$scope.pageId][pIndex][sCode];
                }

                // Remove the shadow response for this section item
                if ($scope.shadowResponse[pIndex] && $scope.shadowResponse[pIndex][sCode] && $scope.shadowResponse[pIndex][sCode][sIndex]) {
                    $scope.shadowResponse[pIndex][sCode].splice(sIndex, 1);
                }

                // deregister watches for this section item
                $scope.deregisterSectionItemWatches(pIndex, sCode, sIndex);

                if ($scope.page.sections) {
                    var section = $filter('filter')($scope.page.sections, { code: sCode }, true)
                    if (section.length && section[0].repeatingItemRequired) {
                        if ($scope.getSectionItemCount($scope.pageId, sCode, pIndex) === 0) {
                            $scope.addSectionItem(pIndex, sCode, true);
                        }
                    }
                }
                else {
                    $scope.utility.focus('sectionAddNewButton-' + pIndex + '-' + sCode);
                }

            });
        }

        //this method implements the roll up functionality for a question, resets the reponse of  a question and hence for all its children questions 
        $scope.resetTheResponse = function (pIndex, sCode, sIndex, qCode) {
            if ($scope.responses && $scope.pageId && pIndex && sCode && sIndex && qCode && $scope.responses[$scope.pageId] && $scope.responses[$scope.pageId][pIndex] && $scope.responses[$scope.pageId][pIndex][sCode] && $scope.responses[$scope.pageId][pIndex][sCode][sIndex]) {
                $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode] = undefined;
                $scope.scrollTo($scope.getQuestionId(qCode, pIndex, sIndex, sCode));
            }
        }

        // Returns if the question is read only or not
        $scope.isReadOnly = function (question) {

            // if the page is read only, return true straight away.
            if ($scope.isPageEditable === false) {
                return true;
            }
            else {
                var readOnly = question.access == 'R';

                if (question.readOnlyCondition) {
                    readOnly = readOnly || ($scope.$eval(question.readOnlyCondition) == true);
                }

                return readOnly;
            }
        }

        // Returns if the question is required/mandatory or not
        $scope.isRequired = function (question) {

            var isRequired = false;

            if (question.showAsRequired) {
                isRequired = $scope.$eval(question.showAsRequired);
            }

            return isRequired;
        }

        // Determines if the next page is a summary page based on the current user. 
        $scope.isNextPageSummary = function () {
            var curNavNo = $scope.navTabNum;
            var curTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == curNavNo; });
            var maxPagesInTab = getMaxPageCountForTab(curNavNo);
            var curPageNo = getPageIndex(curTab, $scope.pageUrl);

            if (curPageNo < (maxPagesInTab - 1)) {
                return (curNavNo == Constants.summaryNavTabNum || curNavNo == Constants.systemNavTabNum) != false;
            }
            else {
                var nextTab = $scope.configData.navigationTabs[($scope.configData.navigationTabs.indexOf(curTab) + 1)];
                return (nextTab.number == Constants.summaryNavTabNum || nextTab.number == Constants.systemNavTabNum) != false;
            }
        }

        // Returns to the landing page.
        $scope.returnToLanding = function () {
            $location.path(Constants.Url.landing);
        }

        // Pads the value with zeroes
        $scope.padValue = function (qCode, pIndex, sIndex, sCode, totalDigits) {
            var resp = $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode];
            if (resp && resp.length > 0 && resp > 0) {
                $scope.responses[$scope.pageId][pIndex][sCode][sIndex][qCode] = Array((totalDigits + 1) - resp.length).join('0') + resp;
            }
        }

        // Gets the number of repeating page items currently for this page.
        $scope.getPageItemCount = function (pageId) {
            var count = 0;
            if ($scope.responses[pageId]) {
                count = $scope.responses[pageId].length;
            }
            return count;
        }

        // Gets the number of repeating section items currently for this section.
        $scope.getSectionItemCount = function (pageId, sCode, pIndex) {
            var count = 0;
            if ($scope.responses && $scope.responses[pageId] && $scope.responses[pageId][pIndex] && $scope.responses[pageId][pIndex][sCode]) {
                count = $scope.responses[pageId][pIndex][sCode].length;
            }
            return count;
        }

        // Verifies all page items have been saved. Returns true if they are saved, false if one or more are not.
        $scope.checkPageItemsAreSaved = function () {
            if ($scope.page.isRepeating === true) {
                var match = _.find($scope.responses[$scope.pageId], function (pageItem) {
                    return pageItem.$state != Constants.RepeatingItemState.viewing
                });
                if (match) {
                    $scope.utility.openPopup($scope.page.repeatingNavigatePopupCode);
                    return false;
                };
            }
            else {
                var IsValid = true;
                _.find($scope.page.sections, function (section) {
                    if (section.isRepeating && section.repeatingReadOnly !== true) {
                        var match = _.find($scope.responses[$scope.pageId][0][section.code], function (sectionItem) {
                            if (sectionItem.$state !== undefined) {
                                return sectionItem.$state != Constants.RepeatingItemState.viewing
                            } else {
                                return false;
                            }
                        });
                        if (match) {
                            var popupCode = $scope.page.sections
                                .find(function (sec) {
                                    return sec.code == section.code;
                                }).repeatingNavigatePopupCode;
                            $scope.utility.openPopup(popupCode);
                            IsValid = false;
                            return false;
                        };
                    }
                });
                if (IsValid === false) {
                    return false;
                }
            }
            return true;
        }

        // Verifies all section items have been saved. Returns true if they are saved, false if one or more are not.
        $scope.checkSectionItemsAreSaved = function (sCode) {
            var match = _.find($scope.responses[$scope.pageId][0][sCode], function (sectionItem) {
                return sectionItem.$state != Constants.RepeatingItemState.viewing
            });
            if (match) {
                var section = _.find($scope.page.sections, function (s) {
                    return s.code == sCode
                });
                $scope.utility.openPopup(section.repeatingNavigatePopupCode);
                return false;
            };
            return true;
        }

        // Initialise response for this page if there isn't one already
        $scope.initialisePageResponse = function () {
            // Initialise response for this page if there isn't one already, skip repeating page items so we don't end up with ghost entries
            if (!$scope.page.isRepeating && $scope.responses[$scope.pageId] == undefined) {
                $scope.responses[$scope.pageId] = [{}];
                if ($scope.page.sections != undefined) {
                    // initialise response for each section if there isn't one already, skip repeating section items so we don't end up with ghost entries
                    for (var s = 0; s < $scope.page.sections.length; s++) {
                        var section = $scope.page.sections[s];
                        if (!section.isRepeating && $scope.responses[$scope.pageId][0][section.code] == undefined) {
                            $scope.responses[$scope.pageId][0][section.code] = [{}];
                        }
                    }
                }
            }
        }
        // this function set the focus to the first element
        $scope.focusFirstElement = function (page, pIndex, sCode, sIndex) {
            //If there are repeating sections: take the first section, and its first element
            var sectionToFocus = page.sections && page.sections.length > 0
                ? (sCode ? $filter('filter')(page.sections, { code: sCode }, true)[0] : page.sections[0])
                : null;

            if (sectionToFocus) {
                var qCode = sectionToFocus.questions && sectionToFocus.questions.length > 0 ? sectionToFocus.questions[0].code : null;
                if (qCode) {
                    var id = $scope.getQuestionId(qCode, pIndex, sIndex, sectionToFocus.code);
                    if (id) {
                        $scope.utility.focus(id);
                    }
                }
            }
        }


        // ******************************************************************************************************
        // NOTE: All local functions below this line. At present, these are not visible to the child controllers.
        // ******************************************************************************************************

        // Returns the current template path. e.g if url is /incident/1/servicedetails this returns incident
        var getCurTemplatePath = function () {
            return $location.$$path.substring(1, $location.$$path.indexOf('/', 1));
        }

        // Generates a unique quid
        var generateGuid = function () {
            // Example of format: f422cb1a-fbc0-45d6-8000-0017b04b4375
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };

        // Returns the total number of pages for the tab
        var getMaxPageCountForTab = function (navNo) {
            // Ensure to consider includeInProgress when counting pages
            var maxPageInTab = 0;
            _.find($scope.configData.navigationTabs, function (o) { return o.number == navNo; }).pages.forEach(function (value) {
                if (value.includeInProgress || navNo == Constants.summaryNavTabNum || navNo == Constants.systemNavTabNum) {
                    maxPageInTab = maxPageInTab + 1;
                }
            });
            return maxPageInTab;
        }

        // Returns the page index for the supplied navtab and pageUrl
        var getPageIndex = function (curTab, pageUrl) {
            var curPageIndex = -1;
            for (var i = 0; i < getMaxPageCountForTab(curTab.number); i++) {
                if (curTab.pages[i].url == pageUrl) {
                    curPageIndex = i;
                    break;
                }
            }
            return curPageIndex;
        }

        // this function returns the page
        var getPage = function (navTabNum, pageUrl) {
            return _.find(_.find($scope.configData.navigationTabs, function (o) { return o.number == navTabNum; }).pages, function (p) { return p.url == pageUrl; });
        }



        // This actually transfers user to next page. Seperated from GoToNextPage so exitConditions can work asynchronously.
        var transferToNextPage = function () {
            var curNavNo = $scope.navTabNum;
            var curTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == curNavNo; });
            var maxPagesInTab = getMaxPageCountForTab(curNavNo);
            var curPageNo = getPageIndex(curTab, $scope.pageUrl);
            var dhordffhPath = $location.$$path.split('/')[2];

            if (curNavNo > 0) {
                if (curPageNo < (maxPagesInTab - 1)) {
                    // navigate to next page in current tab
                    var url = curTab.pages[(curPageNo + 1)].url
                    if ($scope.$eval((curTab.pages[(curPageNo + 1)]).condition, null) != true) {
                        if (curPageNo + 1 < (maxPagesInTab - 1)) {
                            url = curTab.pages[(curPageNo + 2)].url;
                        }
                        else {
                            if (curPageNo + 1 == (maxPagesInTab - 1)) {
                                // navigate to first page in next tab
                                var nextTab = $scope.configData.navigationTabs[($scope.configData.navigationTabs.indexOf(curTab) + 1)];

                                // If no suitable page was found, redirect to landing
                                if (nextTab == null) {
                                    $scope.returnToLanding();
                                }
                                else {
                                    if (($location.path().indexOf('DFFH') > -1)) {
                                        $location.path('DFFH/' + dhordffhPath + '/' + nextTab.number + "/" + nextTab.pages[0].url);
                                    }
                                    else if (($location.path().indexOf('DH') > -1)) {
                                        if (($location.path().indexOf('DH/complaintRegistered') > -1)) {
                                            if (nextTab.title == 'Summary') {
                                                if (!DataServices.isDHHSComplaint) {
                                                    nextTab.pages[0].text = 'Do you consent to the Department of Health (the department):';
                                                }
                                            }
                                        }
                                        else if ($location.path().indexOf('DH/complaint') > -1) {
                                            if (nextTab.title == 'Summary') {
                                                if (!DataServices.isDHHSComplaint) {
                                                    nextTab.pages[0].text = "<p>Please complete this section if you are the person providing the feedback.</p><p>I consent to the Department of Health (the department): </p>";
                                                }
                                            }
                                        }
                                        $location.path('DH/' + dhordffhPath + '/' + nextTab.number + "/" + nextTab.pages[0].url);
                                    }
                                    else {

                                        $location.path(getCurTemplatePath() + '/' + nextTab.number + "/" + nextTab.pages[0].url);
                                    }
                                    return;
                                }
                            }
                        }
                    }
                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('DFFH/' + dhordffhPath + '/' + curNavNo + "/" + url);
                    }
                    else if ($location.path().indexOf('DH') > -1) {
                        $location.path('DH/' + dhordffhPath + '/' + curNavNo + "/" + url);
                    }
                    else {
                        $location.path(getCurTemplatePath() + '/' + curNavNo + "/" + url);
                    }
                    return;
                }
                if (curPageNo == (maxPagesInTab - 1)) {
                    // navigate to first page in next tab
                    var nextTab = $scope.configData.navigationTabs[($scope.configData.navigationTabs.indexOf(curTab) + 1)];

                    // If no suitable page was found, redirect to landing
                    if (nextTab == null) {
                        $scope.returnToLanding();
                    }
                    else {
                        if (($location.path().indexOf('DFFH') > -1)) {
                            $location.path('DFFH/' + dhordffhPath + '/' + nextTab.number + "/" + nextTab.pages[0].url);
                        }
                        else if (($location.path().indexOf('DH') > -1)) {
                            if (($location.path().indexOf('DH/complaintRegistered') > -1)) {
                                if (nextTab.title == 'Summary') {
                                    if (!DataServices.isDHHSComplaint) {
                                        nextTab.pages[0].text = 'Do you consent to the Department of Health (the department):';
                                    }
                                }
                            }
                            else if ($location.path().indexOf('DH/complaint') > -1) {
                                if (nextTab.title == 'Summary') {
                                    if (!DataServices.isDHHSComplaint) {
                                        nextTab.pages[0].text = "<p>Please complete this section if you are the person providing the feedback.</p><p>I consent to the Department of Health (the department): </p>";
                                    }
                                }
                            }
                            $location.path('DH/' + dhordffhPath + '/' + nextTab.number + "/" + nextTab.pages[0].url);
                        }
                        else {

                            $location.path(getCurTemplatePath() + '/' + nextTab.number + "/" + nextTab.pages[0].url);
                        }
                        return;
                    }
                }
            }
        }

        // This actually transfers user to previous page. Seperated from GoToPreviousPage so exitConditions can work asynchronously.
        var transferToPreviousPage = function () {
            if (DataServices.callingPage) {
                $scope.returnToCallingPage();
            }
            else {
                var curNavNo = $scope.navTabNum;
                var curTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == curNavNo; });
                var maxPagesInTab = getMaxPageCountForTab(curNavNo);
                var curPageNo = getPageIndex(curTab, $scope.pageUrl);
                var dhordffhPath = $location.$$path.split('/')[2];

                if (curPageNo == 0) {
                    // navigate to last page in previous tab
                    var prevTab = $scope.configData.navigationTabs[($scope.configData.navigationTabs.indexOf(curTab) - 1)];

                    var pageIndex = (getMaxPageCountForTab(prevTab.number) - 1);
                    if ($scope.$eval((prevTab.pages[(getMaxPageCountForTab(prevTab.number) - 1)]).condition, null) != true) {
                        pageIndex = pageIndex - 1;
                    }

                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('DFFH/' + dhordffhPath + '/' + prevTab.number + "/" + prevTab.pages[pageIndex].url);
                    }
                    else if ($location.path().indexOf('DH') > -1) {
                        $location.path('DH/' + dhordffhPath + '/' + prevTab.number + "/" + prevTab.pages[pageIndex].url);
                    }
                    else {

                        $location.path(getCurTemplatePath() + '/' + prevTab.number + "/" + prevTab.pages[pageIndex].url);
                    }
                }
                else if (curPageNo > 0) {
                    // navigate to previous page in current tab
                    var url = curTab.pages[(curPageNo - 1)].url

                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('DFFH/' + dhordffhPath + '/' + curNavNo + "/" + url);
                    }
                    else if ($location.path().indexOf('DH') > -1) {
                        $location.path('DH/' + dhordffhPath + '/' + curNavNo + "/" + url);
                    }
                    else {
                        $location.path(getCurTemplatePath() + '/' + curNavNo + "/" + url);
                    }
                }
            }
        }

        // *************************************************************************************************************
        // NOTE: Only place code which needs to execute immediately after the controller is initialised below this line
        // *************************************************************************************************************

        var page = getPage($scope.navTabNum, $scope.pageUrl);
        // If the page must have at least one repeating item, add the page item (if not already there)
        if (page.repeatingItemRequired) {
            if ($scope.getPageItemCount($scope.pageId) === 0) {
                $scope.addPageItem();
            }
        }

        // If the section must have at least one repeating item, add the section item (if not already there)
        if (page.sections && page.sections.length > 0) {

            var sectionContainingRepeatingItemRequired = _.filter(page.sections, function (o) { return o.repeatingItemRequired; })

            if (sectionContainingRepeatingItemRequired.length > 0) {
                //initialize the response with the section object incase it is not present.
                $scope.initialisePageResponse();

                _.forEach(sectionContainingRepeatingItemRequired, function (item) {
                    var curNavNo = $scope.navTabNum;
                    var curTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == curNavNo; });
                    if ($scope.getSectionItemCount($scope.pageId, item.code, 0) === 0) {
                        //this will not work when repeating page is true and repeating section is true and isRepeatingSectionRequires is true
                        $scope.addSectionItem(0, item.code, true);
                    }
                });

            }
        }

        // reset page value if page is flagged as such
        if ($scope.page.resetValueOnLoad == true && $scope.isPageEditable) {
            $scope.responses[$scope.pageId] = undefined;
        }

    }]);
}());
